import React from "react";
import { useTranslation } from "react-i18next";
import { MoreFeaturesPricing } from "../../Config/features";

const PricingHighlights: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="pp-highlights">
      <div className="pp-highlights__head">
        <h2 className="pp-highlights__heading">
          <span className="lr-text-gradient">Watermark your precious photos</span>
        </h2>
        <p className="pp-highlights__lede">
          Everything you need to protect and personalise your images — packed into every plan.
        </p>
      </div>

      <div className="pp-highlights__grid">
        {MoreFeaturesPricing.map((f) => (
          <div key={f.title} className="pp-highlights__card">
            <div className="pp-highlights__glow" />
            <div className="pp-highlights__icon">
              <img src={f.img} alt="" />
            </div>
            <h3 className="pp-highlights__title">{t(f.title)}</h3>
            <p className="pp-highlights__body">{t(f.description)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PricingHighlights;
